import Step14 from '@/Classes/FollowUp/FollowUpPatint';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      patientResult: new Step14.Step14(null, '', null, ''),
      allToOtherCodes: [
        { title: 'بخش اورژانس بیمارستان', id: 1 },
        { title: 'اتاق احیا', id: 2 },
        { title: 'cath lab', id: 3 },
        { title: 'CT Scan', id: 4 },
        { title: 'اورژانس هوایی به کد 350', id: 5 },
      ],
      allDeath: [
        { title: 'فساد نعشی', id: 1 },
        { title: '(Rigor Mortis) جمود نعشی', id: 2 },
        {
          title: 'جدا شدن سر از بدن (Decapitation)-( متلاشی شدن بدن (Decomposition))',
          id: 3,
        },
        {
          title: 'جدا شدن سر از بدن (Decapitation)-(سوختن و خاکستر شدن بدن (Incineration))',
          id: 4,
        },
      ],
      endOfLifeInformation: [
        {
          title: 'ختم احیا در حضور پزشک',
          id: 1,
        },
        {
          title: 'ختم احیا با مشاوره پزشک / مسٔول شیفت',
          id: 2,
        },
      ],
      allRevivalsList: [
        {
          label: 'احیا موفق-بازگشت نبض به خودی خود',
          value: 1,
        },
        {
          label: 'احیا موفق-بازگشت تنفس به خودی خود',
          value: 2,
        },
        {
          label: 'احیا ناموفق',
          value: 3,
        },
      ],
      patientVehicleType: null,
      patientVehicleCode: '',
      patientEnfOfLifeInformation: '',
    };
  },
  methods: {
    resultChange: function () {
      this.patientResult.information = '';
      this.patientVehicleType = null;
      this.patientVehicleCode = '';
    },
    setData: function (data) {
      this.patientResult.resultId = data.result.id;
      this.patientResult.information = data.information;
      this.patientResult.note = data.note;
      if (this.patientResult.resultId === 5) {
        const text = data.information.split('(');
        this.patientVehicleType = text[0];
        const patientVehicleCode = this.removeLastCharechter(text[1]);
        this.patientVehicleCode = patientVehicleCode;
      }
    },
    finish: function () {
      if (this.patientResult.resultId == 5) {
        if (!this.patientVehicleType) {
          this.showErrorAlert('نوع کد نمی تواند خالی باشد');
          return;
        }
        if (!this.patientVehicleCode) {
          this.showErrorAlert('کد نمی تواند خالی باشد');
          return;
        }
        if (!this.patientVehicleCode.replace(/\s/g, '').length) {
          this.showErrorAlert('کد نمی تواند خالی باشد');
          return;
        }
        this.patientResult.information =
          this.patientVehicleType + '(' + this.patientVehicleCode + ')';
      }
      if (this.patientResult.resultId != 2 && this.patientResult.resultId != 6 && this.patientResult.resultId != 11) {
        if (!this.patientResult.information) {
          this.showErrorAlert('لطفا همه ی موارد را تکمیل نمایید');
          return;
        }
      }
      if (!this.patientResult.note) {
        this.showErrorAlert('توضیحات نمی تواند خالی باشد');
        return;
      }
      if (!this.patientResult.note.replace(/\s/g, '').length) {
        this.showErrorAlert('توضیحات نمی تواند خالی باشد');
        return;
      }
      this.patientResult.patientId = this.patientId;
      this.addPatientResultFunction(this.patientResult);
    },
    goToPatient: function () {
      let missionPhoneeId = this.missionPhoneId.toString();
      let encryptMissionPhoneId = CryptoJS.AES.encrypt(
        missionPhoneeId,
        'f9rr5r2Dfr7lyf8N',
      ).toString();
      let id = encryptMissionPhoneId;
      this.$router.push({ name: 'followUpMission', params: { id: id } });
    },
    backToStep13: function () {
      this.$root.$refs.FollowUpPatient.changeTab4Step(2, true);
    },
  },
};
